export default "__VITE_ASSET__B5VpF6xz__"